<template>
  <asc-role-grid
    :values="values"
    :on-open="onOpen"
    :add-role="onAddRole"
  ></asc-role-grid>
</template>

<script>
import AscRoleGrid from '@/components/molecules/AscRoleGrid'
export default {
  name: 'AscRoleGridWrapper',
  components: {
    AscRoleGrid,
  },
  props: {
    values: {
      type: Array,
      default: () => [],
    },
    onAddRole: {
      type: Function,
      default: () => {},
    },
    onOpen: {
      type: Function,
      default: () => {},
    },
  },
}
</script>
